import { IEnvironment } from '@app-core/models/environment';

export const environment: IEnvironment = {
  production: true,
  isUnitTest: false,
  version: '${version}',
  name: 'pasfoto-kaartvernieuwing',
  logRelay42ToConsole: false,
  state: {
    key: 'e6617796-93d3-4cbc-a64f-20d0a8f57d39',
    resetTime: 15
  },
  api: {
    mock: false
  }
};
